var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_Set.js
// module id = RIV0
// module chunks = 1